const listeners = new Set()

export function publishCollectionAdded(rows) {
  for (const listener of listeners) listener(rows)
}

export function subscribeCollectionAdded(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

// A bottle's kind, size or count changed (FOS-SAMPLE-TRAVEL-001). Shelves that show
// per-bottle sizes re-read the bottle rows for that fragrance.
const bottleListeners = new Set()

export function publishBottlesChanged(fragranceId) {
  for (const listener of bottleListeners) listener(fragranceId)
}

export function subscribeBottlesChanged(listener) {
  bottleListeners.add(listener)
  return () => bottleListeners.delete(listener)
}
